import React from "react";
import './style.css'
import { FaLocationDot } from "react-icons/fa6";
import { MdStadium } from "react-icons/md";
import { IoMdTime } from "react-icons/io";
import { useRenderMatchResult } from "./hooks/useRenderMatchResult";
import { useNavigate } from "react-router-dom";
import TeamTag from "./components/TeamTag";
import SponsorsFooter from "./components/SponsorsFoooter";




const MatchCard = ({match})=>{
    console.log('match', match)
    const navigate = useNavigate()
    const { renderMatchGameResult } = useRenderMatchResult()
    return(
        <div className="math-card-container" onClick={()=>{
            if(match?.alineacionLocal || match?.alineacionVisitante) return navigate(`/lineup/matches/${match?._id}`)

        } }>
            <div className="math-card-container-header">
                <div className="match-card-tournament-info-header">
                    <img className="tournament-logo-header" src={match?.torneo?.imgPicture} />
                    <p>{match?.torneo?.name}</p>
                </div>
                <div className="match-card-tournament-journal">
                    <p>{match?.jornada}</p>
                </div>
            </div>
            <div className="math-card-container-body">

                <TeamTag tag={'local'} team={match?.equipoLocal} />
                <div className="math-card-container-body-schedule-info">
                        {renderMatchGameResult(match)}
                    <div className="math-card-container-body-location">
                    <FaLocationDot />
                    <p> {match?.estadio}</p>

                    </div>

                <a  target="_blank" href={match?.ubicacion} className="math-card-container-body-link">
                    <MdStadium />
                    <p>Como llegar</p>
                    
                </a>
                </div>
                <TeamTag team={match?.equipoVisitante} tag={'visitor'} />

            </div>
            <div className="divider-line"></div>
            <div className="math-card-container-footer">
                <div className="match-card-footer-schedule-time">
                    <IoMdTime size={18} color="rgba(255, 255, 255, 0.5)" />
                <p className="match-card-footer-text">{match?.horario}</p>

                </div>

            </div>
            <SponsorsFooter />

        </div>
    )
}

export default MatchCard